import { Companion_getInstance14tgug8r8maei as Companion_getInstance } from './ExecutionContext.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { HttpHeader1d7ldebjomr00 as HttpHeader } from './http/Http.mjs';
import { plus20p0vtfmu0596 as plus } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { uuid4al7pp0fcb8o5 as uuid4 } from '../../../../../uuid/com/benasher44/uuid/uuid.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var BuilderClass;
function Builder() {
  if (BuilderClass === VOID) {
    class $ {
      constructor(operation) {
        this.h42_1 = operation;
        this.i42_1 = null;
        this.j42_1 = Companion_getInstance().y42_1;
        this.k42_1 = null;
        this.l42_1 = null;
        this.m42_1 = null;
        this.n42_1 = null;
        this.o42_1 = null;
        this.p42_1 = null;
        this.q42_1 = null;
        this.r42_1 = null;
        this.s42_1 = null;
        this.t42_1 = null;
        this.u42_1 = null;
        this.v42_1 = true;
        this.w42_1 = null;
        this.x42_1 = null;
      }
      z42(requestUuid) {
        // Inline function 'kotlin.apply' call
        this.i42_1 = requestUuid;
        return this;
      }
      a43(executionContext) {
        // Inline function 'kotlin.apply' call
        this.j42_1 = executionContext;
        return this;
      }
      b43(ignoreApolloClientHttpHeaders) {
        // Inline function 'kotlin.apply' call
        this.s42_1 = ignoreApolloClientHttpHeaders;
        return this;
      }
      c43(url) {
        // Inline function 'kotlin.apply' call
        this.k42_1 = url;
        return this;
      }
      d43(httpMethod) {
        // Inline function 'kotlin.apply' call
        this.l42_1 = httpMethod;
        return this;
      }
      e43(httpHeaders) {
        // Inline function 'kotlin.apply' call
        this.m42_1 = httpHeaders;
        return this;
      }
      f43(name, value) {
        // Inline function 'kotlin.apply' call
        var tmp = this;
        var tmp0_elvis_lhs = this.m42_1;
        tmp.m42_1 = plus(tmp0_elvis_lhs == null ? emptyList() : tmp0_elvis_lhs, new (HttpHeader())(name, value));
        return this;
      }
      g43(sendApqExtensions) {
        // Inline function 'kotlin.apply' call
        this.o42_1 = sendApqExtensions;
        return this;
      }
      h43(sendDocument) {
        // Inline function 'kotlin.apply' call
        this.p42_1 = sendDocument;
        return this;
      }
      i43(enableAutoPersistedQueries) {
        // Inline function 'kotlin.apply' call
        this.n42_1 = enableAutoPersistedQueries;
        return this;
      }
      j43(canBeBatched) {
        // Inline function 'kotlin.apply' call
        this.q42_1 = canBeBatched;
        return this;
      }
      k43(ignoreUnknownKeys) {
        // Inline function 'kotlin.apply' call
        this.r42_1 = ignoreUnknownKeys;
        return this;
      }
      l43(retryOnError) {
        // Inline function 'kotlin.apply' call
        this.t42_1 = retryOnError;
        return this;
      }
      m43(failFastIfOffline) {
        // Inline function 'kotlin.apply' call
        this.u42_1 = failFastIfOffline;
        return this;
      }
      n43(sendEnhancedClientAwareness) {
        // Inline function 'kotlin.apply' call
        this.v42_1 = sendEnhancedClientAwareness;
        return this;
      }
      o43(extensions) {
        // Inline function 'kotlin.apply' call
        this.w42_1 = extensions;
        return this;
      }
      e3a() {
        var tmp1_operation = this.h42_1;
        var tmp0_elvis_lhs = this.i42_1;
        var tmp2_requestUuid = tmp0_elvis_lhs == null ? uuid4() : tmp0_elvis_lhs;
        var tmp3_executionContext = this.j42_1;
        var tmp4_httpMethod = this.l42_1;
        var tmp5_httpHeaders = this.m42_1;
        var tmp6_sendApqExtensions = this.o42_1;
        var tmp7_sendDocument = this.p42_1;
        var tmp8_enableAutoPersistedQueries = this.n42_1;
        var tmp9_canBeBatched = this.q42_1;
        var tmp10_ignoreApolloClientHttpHeaders = this.s42_1;
        var tmp11_retryOnError = this.t42_1;
        var tmp12_failFastIfOffline = this.u42_1;
        var tmp13_ignoreUnknownKeys = this.r42_1;
        var tmp14_sendEnhancedClientAwareness = this.v42_1;
        var tmp15_url = this.k42_1;
        var tmp16_extensions = this.w42_1;
        var tmp17_onError = this.x42_1;
        return new (ApolloRequest())(tmp1_operation, tmp2_requestUuid, tmp16_extensions, tmp17_onError, tmp3_executionContext, tmp15_url, tmp4_httpMethod, tmp5_httpHeaders, tmp6_sendApqExtensions, tmp7_sendDocument, tmp8_enableAutoPersistedQueries, tmp9_canBeBatched, tmp13_ignoreUnknownKeys, tmp10_ignoreApolloClientHttpHeaders, tmp11_retryOnError, tmp12_failFastIfOffline, tmp14_sendEnhancedClientAwareness);
      }
    }
    initMetadataForClass($, 'Builder');
    BuilderClass = $;
  }
  return BuilderClass;
}
var ApolloRequestClass;
function ApolloRequest() {
  if (ApolloRequestClass === VOID) {
    class $ {
      constructor(operation, requestUuid, extensions, onError, executionContext, url, httpMethod, httpHeaders, sendApqExtensions, sendDocument, enableAutoPersistedQueries, canBeBatched, ignoreUnknownKeys, ignoreApolloClientHttpHeaders, retryOnError, failFastIfOffline, sendEnhancedClientAwareness) {
        this.p43_1 = operation;
        this.q43_1 = requestUuid;
        this.r43_1 = extensions;
        this.s43_1 = onError;
        this.t43_1 = executionContext;
        this.u43_1 = url;
        this.v43_1 = httpMethod;
        this.w43_1 = httpHeaders;
        this.x43_1 = sendApqExtensions;
        this.y43_1 = sendDocument;
        this.z43_1 = enableAutoPersistedQueries;
        this.a44_1 = canBeBatched;
        this.b44_1 = ignoreUnknownKeys;
        this.c44_1 = ignoreApolloClientHttpHeaders;
        this.d44_1 = retryOnError;
        this.e44_1 = failFastIfOffline;
        this.f44_1 = sendEnhancedClientAwareness;
      }
      g44() {
        return this.h44(this.p43_1);
      }
      h44(operation) {
        return (new (Builder())(operation)).z42(this.q43_1).a43(this.t43_1).c43(this.u43_1).d43(this.v43_1).e43(this.w43_1).g43(this.x43_1).h43(this.y43_1).i43(this.z43_1).j43(this.a44_1).l43(this.d44_1).m43(this.e44_1).b43(this.c44_1).k43(this.b44_1).n43(this.f44_1).o43(this.r43_1);
      }
    }
    initMetadataForClass($, 'ApolloRequest');
    ApolloRequestClass = $;
  }
  return ApolloRequestClass;
}
//region block: exports
export {
  Builder as Builder32honxq3tatym,
};
//endregion

//# sourceMappingURL=ApolloRequest.mjs.map
